<template>
  <v-layout row justify-center>
    <v-dialog v-model="displayForm" persistent max-width="980px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="headline">Update Set</span>
          </v-card-title>
          <div class="text-xs-center">
            <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
          </div>
          <v-card-text v-if="!loading && productSet">
            <v-alert
              :value="message"
              type="error"
              dismissible
              transition="scale-transition"
            >{{ message }}</v-alert>

            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs10 md10>
                  <product-autocomplete
                    label="Product"
                    v-model="productId"
                    :filters="productFilters"
                  ></product-autocomplete>
                </v-flex>
                <v-flex xs2 md2>
                  <v-btn :disabled="!productId" @click="addProduct">Add</v-btn>
                </v-flex>
                <v-flex xs12 md12>
                  <v-data-table :headers="headers" :items="productSet.products">
                    <template v-slot:items="props">
                      <td>{{ props.item.code }}</td>
                      <td>{{ props.item.sku }}</td>
                      <td>{{ props.item.description }}</td>
                      <td class="justify-center layout px-0">
                        <v-icon small @click="deleteItem(props.item)">mdi-delete</v-icon>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close()" :disabled="loading">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
import ProductAutocomplete from "@components/forms/autocomplete/Product.vue";

export default {
  components: {
    ProductAutocomplete
  },
  props: ["item", "open", "headers"],
  data() {
    return {
      productSet: null,
      productId: null,
      valid: null,
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null
    };
  },
  watch: {
    item: function(newProductSet) {
      this.productSet = newProductSet;
    }
  },
  computed: {
    displayForm: function() {
      return this.open;
    },
    loading: function() {
      return this.$store.getters["lists/loading"];
    },
    productFilters: function() {
      return {
        setId: null,
        dominantHand: this.productSet.dominantHand,
        classification: this.productSet.classification
      };
    }
  },

  methods: {
    refresh() {
      this.$store
        .dispatch("productSets/view", {
          id: this.productSet.id
        })
        .then(data => {
          this.productSet = data;
        });
    },
    close() {
      this.$emit("cancel");
      this.resetForm();
    },
    resetForm() {
      this.productSet = null;
      this.$refs.form.reset();
    },
    deleteItem(item) {
      this.$store
        .dispatch("products/updateSet", {
          code: item.code,
          setId: null
        })
        .finally(() => {
          this.refresh();
        });
    },
    addProduct() {
      this.$store
        .dispatch("products/updateSet", {
          code: this.productId,
          setId: this.productSet.id
        })
        .finally(() => {
          this.refresh();
        });
    }
  }
};
</script>

<style></style>
